import { ContextualUpsellDialog } from '@/components/common/contextual-upsell/contextual-upsell-dialog'
import { useContextStore } from '@/stores/context'
import { useContextualUpsellStore } from '@/stores/contextual-upsell'

/**
 * Global ContextualUpsellProvider component
 * Renders the ContextualUpsellDialog based on the global contextual upsell store state
 * Only shows for users without an active subscription
 * Should be rendered once at the root/app layout level
 */
export function ContextualUpsellProvider() {
  const isOpen = useContextualUpsellStore((state) => state.isOpen)
  const upsell = useContextualUpsellStore((state) => state.upsell)
  const source = useContextualUpsellStore((state) => state.source)
  const hideContextualUpsell = useContextualUpsellStore(
    (state) => state.hideContextualUpsell,
  )

  const hasActiveSubscription = useContextStore(
    (state) => state.userAccountContext?.hasActiveSubscription,
  )

  if (!upsell || hasActiveSubscription) {
    return null
  }

  return (
    <ContextualUpsellDialog
      upsell={upsell}
      open={isOpen}
      onOpenChange={hideContextualUpsell}
      source={source}
    />
  )
}
